import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { PaymentCardType } from '@mews/enums';

import { getSelectedEnterpriseSupportedPaymentCardTypes } from '../../../../selectors/views/selectedEnterprisePaymentConfiguration';
import { getCurrentPaymentCardType } from '../../slices';
import { ApplicationState } from '../../../../types';

export const inject = connect(
    createStructuredSelector<
        ApplicationState,
        $TSFixMe,
        { supportedTypes: PaymentCardType[]; currentType: PaymentCardType | null | undefined }
    >({
        supportedTypes: getSelectedEnterpriseSupportedPaymentCardTypes,
        currentType: getCurrentPaymentCardType,
    })
);
